import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const HomeSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "HomeSettingsPage" */ "@circle-react/components/SettingsApp/Home"
    ),
);

export const HomeSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <HomeSettingsComponent />
  </Suspense>
);
